import { registerBcfAppId } from '@bcf-vanilla-ts-v1-configurators/tokens/app/token';
import { provideWorker } from '@bcf-vanilla-ts-v1-platforms/platform-worker/browser/providers';
import { registerDiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import { registerElement } from '@bcf2-shared-pkg-v1/ui/shared/classes/bcf-lit-element';
import { mobileLitswRegistrationConfig } from '@bcf2-v1-configurators-tokens/litsw-registration/litsw-registration-presets';
import { LITSW_REGISTRATION_CONFIG } from '@bcf2-v1-configurators-tokens/litsw-registration/token';
import { registerEnvCommon } from '@bcflit-env/env-token';
import { envCommon } from '@bcflit-env/tikal-casino/env.prod';
import '@bcflit-polyfills';
import { registerAppProviders } from '../../../mobile/app/app.providers';
import { registerSettingsProviders } from '../../../mobile/app/settings.providers';
import { AppElement } from '../../app/app';
import { bootstrapAppI18n } from './../../../app-i18n';

async function main(): Promise<void> {
  const appRuntimeId: number = new Date().getTime();
  const worker: Worker = new Worker(new URL('./main.worker.ts', import.meta.url), { type: 'module' });
  bootstrapAppI18n(envCommon);
  provideWorker(worker, appRuntimeId, 'mobile-web-twa');
  registerBcfAppId('cs-tikal-casino-mobile-web-twa');
  registerAppProviders();
  registerEnvCommon(envCommon);
  registerSettingsProviders(envCommon);
  registerDiToken(LITSW_REGISTRATION_CONFIG, () => mobileLitswRegistrationConfig);
  registerElement(AppElement);
}
main();
